import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IResponseOptionGroup } from '../models';
import { GetResponseOptionGroups } from '../services/CommonQuestionAPI';
import { ActionTypes as CommonActionTypes } from './ActionTypes';

export interface IResponseOptionGroupState {
	isLoadingResponseOptionGroups: boolean;
	responseOptionGroups: IResponseOptionGroup[];
}

export const initialState: IResponseOptionGroupState = {
	isLoadingResponseOptionGroups: false,
	responseOptionGroups: [],
};

export const loadResponseOptionGroups = createAsyncThunk(
	'surveyDimensions/loadResponseOptionGroups',
	async (cultureCode: string, { dispatch, rejectWithValue }) => {
		try {
			const responseOptionGroups = await GetResponseOptionGroups(cultureCode);
			return { responseOptionGroups };
		} catch (error) {
			dispatch({ type: CommonActionTypes.TOAST_WARNING_NOTIFICATION, payload: '' });
			rejectWithValue(error);
		}
	},
);

const responseOptionGroupSlice = createSlice({
	name: 'responseOptionGroups',
	initialState: initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(loadResponseOptionGroups.pending, (state) => {
				state.isLoadingResponseOptionGroups = true;
			})
			.addCase(loadResponseOptionGroups.fulfilled, (state, action) => {
				state.responseOptionGroups = action.payload?.responseOptionGroups ?? [];
				state.isLoadingResponseOptionGroups = false;
			})
			.addCase(loadResponseOptionGroups.rejected, (state) => {
				state.isLoadingResponseOptionGroups = false;
			});
	},
});

export default responseOptionGroupSlice.reducer;
